import React, { ComponentType, PureComponent } from 'react';
import { SelectedMethodContext } from 'services/SelectedMethodContext';

const withSelectedMethodContext = <P extends object>(Component: ComponentType<P>) => {
  class WithContext extends PureComponent<P> {
    render() {
      return (
        <SelectedMethodContext.Consumer>
          {value => <Component {...this.props} {...value} />}
        </SelectedMethodContext.Consumer>
      );
    }
  }

  return WithContext;
};

export default withSelectedMethodContext;
